import numeral from 'numeral';

/**
 * 10000 -> $100.00
 */
export const toCurrency = (amount: number): string => numeral(amount).divide(100).format('$0,0.00');
